module.exports = __webpack_public_path__ + "static/img/fusion.814575c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VX/mintWalks/fusion.gif
// module id = L7rG
// module chunks = 1